"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentInsertedSubDocumentChange = void 0;
var ContentInsertedSubDocumentChange = (function () {
    function ContentInsertedSubDocumentChange(subDocumentId, position, length) {
        this.subDocumentId = subDocumentId;
        this.position = position;
        this.length = length;
    }
    ContentInsertedSubDocumentChange.prototype.canContinuesWith = function (nextChange) {
        if (nextChange.subDocumentId != this.subDocumentId)
            return false;
        if (nextChange.position != (this.position + this.length))
            return false;
        return true;
    };
    return ContentInsertedSubDocumentChange;
}());
exports.ContentInsertedSubDocumentChange = ContentInsertedSubDocumentChange;
